import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { ErrorBoundary } from '@examflow/ui';

export { ErrorBoundary };

export function QuizErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary
      fallback={
        <div className="max-w-2xl mx-auto px-4 py-12">
          <div className="card text-center">
            <div className="flex justify-center mb-4">
              <AlertTriangle className="w-16 h-16 text-warning-500" />
            </div>
            <h2 className="text-2xl font-bold mb-4">答题页面出现了问题</h2>
            <p className="text-slate-600 mb-6">
              页面遇到了意外错误，您的答题进度已自动保存。请刷新页面重试。
            </p>
            <div className="flex justify-center gap-3">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
              >
                刷新页面
              </button>
              <button
                type="button"
                onClick={() => {
                  window.location.href = '/';
                }}
                className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300 transition-colors"
              >
                返回首页
              </button>
            </div>
          </div>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
}
